var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconAcceptAllGreen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.588,
    height: 18.859,
    viewBox: "0 0 21.588 18.859",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ICON_Aktualisierung_\\xFCbernehmen",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_705",
    "data-name": "Pfad 705",
    d: "M7708.21,3099.612l1.788,2.7,5.233-6.061",
    transform: "translate(-7703.21 -3090.753)",
    fill: "none",
    stroke: "#047c89",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_554",
    "data-name": "Pfad 554",
    d: "M1514.517,818.044a8.421,8.421,0,1,1-6.61-5.915",
    transform: "translate(-1498 -812)",
    fill: "none",
    stroke: "#047c89",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Pfad_397",
    "data-name": "Pfad 397",
    transform: "translate(16.997 12.56) rotate(-144)",
    fill: "#047c89",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 7.487906455993652 7.192298889160156 C 6.077268600463867 7.024150848388672 4.437997817993164 6.827566623687744 3.340615510940552 6.693644046783447 C 3.745007038116455 6.402688503265381 4.23405647277832 6.054077625274658 4.695025444030762 5.727968692779541 L 5.032635688781738 5.489128589630127 L 5.102935791015625 5.081598281860352 C 5.187696933746338 4.590267181396484 5.297985076904297 3.954351186752319 5.396928787231445 3.388648509979248 C 5.657505035400391 3.86408257484436 5.961948394775391 4.418435096740723 6.266525745391846 4.972508430480957 C 6.722161769866943 5.801400184631348 7.178130626678467 6.62975025177002 7.487906455993652 7.192298889160156 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 5.145208358764648 1.371487617492676 C 5.300726413726807 1.371487617492676 5.454178333282471 1.440218925476074 5.539395809173584 1.55595874786377 C 5.539393424987793 1.555957794189453 5.539391040802002 1.555957794189453 5.539389133453369 1.555957794189453 C 5.523703098297119 1.555957794189453 8.752415657043457 7.415338516235352 8.752415657043457 7.415338516235352 C 9.027026176452637 7.973697185516357 8.653284072875977 8.288356781005859 8.271738052368164 8.288356781005859 C 8.235335350036621 8.288356781005859 8.198894500732422 8.285495758056641 8.162905693054199 8.279708862304688 C 8.162905693054199 8.279708862304688 1.910725593566895 7.536548614501953 1.936275482177734 7.522868156433105 C 1.533755302429199 7.341828346252441 1.462045669555664 6.803058624267578 1.786435127258301 6.605218410491943 C 1.773975372314453 6.569488525390625 4.117495536804199 4.911598682403564 4.117495536804199 4.911598682403564 C 4.117495536804199 4.911598682403564 4.652045726776123 1.812878608703613 4.66834545135498 1.794088363647461 C 4.724761486053467 1.494928359985352 4.936829566955566 1.371487617492676 5.145208358764648 1.371487617492676 Z",
    stroke: "none",
    fill: "#047c89"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAcceptAllGreen);
export default __webpack_public_path__ + "static/media/icon_accept_all_green.94dda68867041186b3f949cdca78749f.svg";
export { ForwardRef as ReactComponent };